import React, { useState, useEffect } from "react";
import Select from "../../ui/PortalSelect";
import "antd/dist/antd.css";
import { DatePicker } from "antd";
import Swal from "sweetalert2";
import moment from "moment";
import axios from "axios";
import { baseURL } from "../backend_url";
import "./style.css";
// import * as XLSX from "xlsx";
import { Button } from "@mui/material";
import * as XLSX from "xlsx-js-style";
import { getEntitySelectProps } from '../../ui/selectPresentation';
import {
  deriveVendorAccountSelection,
  loadAccessibleCompanies,
  readSessionUser,
} from '../accountAccess';

export default function Reservation({ accessType }) {
  const [responseData, setData] = useState(null);
  const [otaDetail, setotaDetail] = useState([]);
  const [otaName, setOtaName] = useState([]);
  const [ota_id, setota_id] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loggedInUserDetail, setLoggedInUserDetail] = useState({});
  const [fetchClicked, setFetchClicked] = useState(false);
  const [basedOn, setBasedOn] = useState("Booked Date");
  const [bookingStatus, setBookingStatus] = useState("All");
  const [loading, setLoading] = useState(false);
  const [companyDetail, setCompanyDetail] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const [companyNumber, setCompanyNumber] = useState("");
  const [accountSelectorDisabled, setAccountSelectorDisabled] = useState(false);

  //API call
  useEffect(() => {
    const { user, error } = readSessionUser();
    if (error) {
      Swal.fire({ icon: 'error', title: 'Accounts unavailable', text: error });
      return;
    }

    setLoggedInUserDetail(user);
    loadAccessibleCompanies(baseURL, user, 'Reservations_Account Access')
      .then((accounts) => {
        const selection = deriveVendorAccountSelection(accounts, user);
        setCompanyDetail(selection.accounts);
        setAccountSelectorDisabled(selection.isSelectorDisabled);
        if (selection.shouldAutoSelect) {
          setCompanyName(selection.selectedAccountName);
          setCompanyNumber(selection.selectedAccountId);
        }
      })
      .catch((loadError) => {
        setCompanyDetail([]);
        setAccountSelectorDisabled(false);
        Swal.fire({
          icon: 'error',
          title: 'Accounts unavailable',
          text: loadError.message || 'Accounts could not be loaded.',
        });
      });
  }, []);

  useEffect(() => {
    setotaDetail([]);
    setOtaName([]);
    if (!companyNumber) {
      return;
    }
    axios.get(baseURL + "/get_ota_details_for_reports", {
      params: { companyNumber }
    }).then((res) => {
      setotaDetail(res.data);
    });
  }, [companyNumber]);

  const companyOptions = companyDetail.map((company) => ({
    value: company._id.toString(),
    label: `${company.company_name} (${company._id})`,
  }));

  const handleCompanyChange = (selectedCompany) => {
    const selectedAccount = companyDetail.find(
      (company) => String(company._id) === String(selectedCompany?.value || '')
    );
    setCompanyNumber(selectedCompany?.value || '');
    setCompanyName(selectedAccount?.company_name || '');
  };

  //Option for company name
  const otaNameOptions = [
    { value: "ALL", label: "Select All" }, // special option
    ...otaDetail.map((value) => ({
      value: value.ota_name,
      label: value.ota_name,
    })),
  ];

  const handleInputChangeOTAName = (selectedOptions) => {
    if (!selectedOptions) {
      setOtaName([]);
      return;
    }

    if (selectedOptions.some((opt) => opt.value === "ALL")) {
      if (otaName.length === otaDetail.length) {
        setOtaName([]);
      } else {
        const allOptions = otaDetail.map((value) => ({
          value: value.ota_name,
          label: value.ota_name,
        }));
        setOtaName(allOptions);
      }
    } else {
      setOtaName(selectedOptions);
    }
  };

  useEffect(() => {
    if (otaDetail && otaName.length > 0) {
      const selectedOtas = otaDetail.filter((value) =>
        otaName.some((o) => o.value === value.ota_name)
      );
      const ota_id_list = selectedOtas.map((o) => o.ota_id);
      setota_id(ota_id_list);
    } else {
      setota_id([]);
    }
  }, [otaName, otaDetail]);

  // Handle Submit Starts
  const handleFetch = (e) => {
    e.preventDefault();
    if (!companyNumber) {
      Swal.fire("Please select an account to proceed ahead");
      return;
    }
    if (otaName.length === 0) {
      Swal.fire("Please select an OTA to proceed ahead");
      return;
    }
    if (fromDate === "") {
      Swal.fire("Please select From Date to proceed ahead");
      return;
    }
    if (toDate === "") {
      Swal.fire("Please select To Date to proceed ahead");
      return;
    }
    if (basedOn === "") {
      Swal.fire("Please select one Based On Option");
      return;
    }
    if (bookingStatus === "") {
      Swal.fire("Please select one Booking Status Option");
      return;
    }

    setLoading(true);
    axios
      .post(baseURL + "/get_partner_report_data", {
        companyNumber,
        account_id: companyNumber,
        ota_id: ota_id.map(String),
        from_date: new Date(fromDate).toDateString(),
        to_date: new Date(toDate).toDateString(),
        based_on: basedOn,
        booking_status: bookingStatus,
      })
      .then((res) => {
        setData({
          headers: res.data.headers,
          rows: res.data.rows,
        });
        setFetchClicked(true);
      })
      .catch((error) => {
        console.error('Unable to load Partner Report data:', error)
        Swal.fire({ icon: 'error', title: 'Request failed', text: 'Unable to load Partner Report data. Please try again.' })
      })
      .finally(() => setLoading(false));
  };

  const handleDownloadExcel_old = () => {
    if (!responseData) return;
    // Meta info rows (filters)
    const metaData = [
      { Field: "From Date", Value: moment(fromDate).format("YYYY-MM-DD") },
      { Field: "To Date", Value: moment(toDate).format("YYYY-MM-DD") },
      { Field: "Booking Status", Value: bookingStatus },
      {}, // blank row for spacing
    ];

    // Convert meta rows
    const ws = XLSX.utils.json_to_sheet(metaData, { skipHeader: true });

    // Append summary rows (reservation count details)
    // XLSX.utils.sheet_add_json(ws, responseData.rows, {
    //   origin: -1,
    //   skipHeader: false,
    // });

    const orderedHeaders = [
      "OTA",
      ...responseData.headers.slice(1).flatMap((h) =>
        h.subheaders.map((sub) => sub.code)
      ),
    ];

    // Reorder rows according to orderedHeaders
    const orderedRows = responseData.rows.map((row) => {
      const newRow = {};
      orderedHeaders.forEach((key) => {
        newRow[key] = row[key] || 0;
      });
      return newRow;
    });

    XLSX.utils.sheet_add_json(ws, orderedRows, {
      origin: -1,
      header: orderedHeaders,
      skipHeader: false,
    });

    // === Auto-fit column width ===
    const allData = [
      ...metaData.map((row) => Object.values(row)),
      Object.keys(responseData.rows[0]), // headers
      ...responseData.rows.map((row) => Object.values(row)),
    ];
    const maxCols = Math.max(...allData.map((row) => row.length));
    const colWidths = Array.from({ length: maxCols }).map((_, colIndex) => ({
      wch:
        Math.max(
          ...allData.map((row) =>
            row[colIndex] ? row[colIndex].toString().length : 0
          )
        ) + 2,
    }));

    ws["!cols"] = colWidths;

    // Create workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Reservations");

    // Save file
    XLSX.writeFile(wb, "reservation_report.xlsx");
  };

  const handleDownloadExcel = () => {
    if (!responseData) return;

    // Meta info rows (filters)
    const metaData = [
      { Field: "From Date", Value: moment(fromDate).format("YYYY-MM-DD") },
      { Field: "To Date", Value: moment(toDate).format("YYYY-MM-DD") },
      { Field: "Booking Status", Value: bookingStatus },
      {}, // blank row
    ];

    // === Build headers ===
    const countryRow = ["OTA"];
    const airportRow = ["OTA"];
    const merges = [];
    let colIndex = 1; // because col 0 is OTA

    responseData.headers.slice(1).forEach((h) => {
      if (h.subheaders.length > 0) {
        // Add country name once, spanning across its subheaders
        countryRow.push(h.header);
        for (let i = 1; i < h.subheaders.length; i++) {
          countryRow.push(null); // keep empty for merged cells
        }

        // Merge instruction: rowIndex, colStart → colEnd
        merges.push({
          s: { r: metaData.length, c: colIndex }, // start (row, col)
          e: { r: metaData.length, c: colIndex + h.subheaders.length - 1 }, // end
        });

        // Add airport codes under the merged country
        h.subheaders.forEach((sub) => {
          airportRow.push(sub.code);
        });

        colIndex += h.subheaders.length;
      } else {
        countryRow.push(h.header);
        airportRow.push("");
        merges.push({
          s: { r: metaData.length, c: colIndex },
          e: { r: metaData.length + 1, c: colIndex },
        });
        colIndex++;
      }
    });

    // === Build OTA rows ===
    const orderedRows = responseData.rows.map((row) => {
      const newRow = [];
      newRow.push(row["OTA"]);
      responseData.headers.slice(1).forEach((h) => {
        if (h.subheaders.length > 0) {
          h.subheaders.forEach((sub) => {
            newRow.push(row[sub.code] || 0);
          });
        } else {
          newRow.push(row[h.header] || 0);
        }
      });
      return newRow;
    });

    // === Combine everything into one 2D array ===
    const allData = [
      ...metaData.map((r) => Object.values(r)),
      countryRow,
      airportRow,
      ...orderedRows,
    ];

    // === Convert to sheet ===
    const ws = XLSX.utils.aoa_to_sheet(allData);

    // === Apply merges (for country cells) ===
    ws["!merges"] = merges;

    // === Auto column width ===
    // const maxCols = Math.max(...allData.map((row) => row.length));
    // ws["!cols"] = Array.from({ length: maxCols }).map((_, colIndex) => ({
    //   wch: Math.max(...allData.map((row) => (row[colIndex] ? row[colIndex].toString().length : 0))) + 2,
    // }));

    // === Apply borders + alignment ===
    const range = XLSX.utils.decode_range(ws["!ref"]);
    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
        if (!ws[cellRef]) continue;

        ws[cellRef].s = {
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
          alignment: {
            horizontal: "center",
            vertical: "center",
            wrapText: true,
          },
        };
      }
    }

    // === Style the country row specifically ===
    const countryRowIndex = metaData.length; // row index of countryRow
    countryRow.forEach((cell, idx) => {
      const cellRef = XLSX.utils.encode_cell({ r: countryRowIndex, c: idx });
      if (ws[cellRef]) {
        ws[cellRef].s = {
          font: { bold: true },
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
          alignment: {
            horizontal: "center",
            vertical: "center",
            wrapText: true,
          },
        };
      }
    });

    // === Apply styles to merged ranges (like country cells) ===
    merges.forEach((merge) => {
      for (let R = merge.s.r; R <= merge.e.r; ++R) {
        for (let C = merge.s.c; C <= merge.e.c; ++C) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!ws[cellRef]) ws[cellRef] = { t: "s", v: "" }; // ensure cell exists

          ws[cellRef].s = {
            font: { bold: true },
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
            alignment: {
              horizontal: "center",
              vertical: "center",
              wrapText: true,
            },
          };
        }
      }
    });

    // === Create workbook ===
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Reservations");

    // Save file
    XLSX.writeFile(wb, "partner_report.xlsx");
  };

  return (
    <>
      <div className="row pt-3">
        <div className="col-11 mx-3">
          <div className="row">
            <div className="col-md-2 mb-3">
              <label htmlFor="company_name" className="form-label">
                Account*
              </label>
            </div>
            <div className="col-md-3 mb-3">
              <Select
                {...getEntitySelectProps()}
                value={companyNumber ? {
                  value: companyNumber,
                  label: `${companyName} (${companyNumber})`,
                } : null}
                inputId="company_name"
                name="company_name"
                options={companyOptions}
                onChange={handleCompanyChange}
                isDisabled={accountSelectorDisabled}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-2 mb-3">
              <label htmlFor="ota_name" className="form-label">
                OTA*
              </label>
            </div>
            <div className="col-md-3 mb-3">
              <Select
                className="partner-report-ota-select"
                classNamePrefix="partner-report-ota-select"
                isMulti
                value={otaName}
                inputId="ota_name"
                name="ota_name"
                options={otaNameOptions}
                onChange={handleInputChangeOTAName}
              />
            </div>
            <div className="col-md-1 mb-3"></div>
          </div>

          {otaName ? (<>
            <div className="row mt-3">
              <div className="col-12 mb-4 ">

                <div className="row mb-4">
                  <span style={{ color: '#1E1E1E', fontSize: '21px' }}>Filters : </span>
                </div>

                <div className="row mt-3">
                  <div className="col-md-2 mb-3">
                    <label htmlFor="company_name" className="form-label">
                      Based On*
                    </label>
                  </div>

                  <div className="col-md-3 mb-3">

                    <select className="form-select" aria-label="Default select example" value={basedOn} onChange={(e) => setBasedOn(e.target.value)}>
                      <option hidden>Choose One</option>
                      <option value="Booked Date">Booked Date</option>
                      {(Object.keys(loggedInUserDetail).length > 0 && loggedInUserDetail.account_type._id != '767610')?
                        <option value="PickUp Date">PickUp Date</option>
                      :""}
                      <option value="DropOff Date">DropOff Date</option>
                    </select>
                  </div>

                  <div className="col-md-1 mb-3"></div>
                  
                  <div className="col-md-2 mb-3">
                    <label htmlFor="location_name" className="form-label">
                      Booking Status*
                    </label>
                  </div>
                  <div className="col-md-3 mb-3">
                    <select className="form-select" aria-label="Default select example" value={bookingStatus} onChange={(e) => setBookingStatus(e.target.value)}>
                      <option hidden>Choose One</option>
                      <option value="All" >All</option>
                      <option value="Valid">Valid</option>
                      <option value="Cancelled">Cancelled</option>
                      <option value="No Show">No Show</option>
                      <option value="Not Qualified">Not Qualified</option>
                    </select>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-md-2 mb-3">
                    <label htmlFor="location_name" className="form-label">
                      From Date*
                    </label>
                  </div>
                  <div className="col-md-3 mb-3">
                    <DatePicker size="large" format='MM-DD-YYYY' placeholder='mm-dd-yyyy' onChange={(date, dateString) => {
                      setFromDate(date);
                    }}
                      style={{ width: '100%', position: 'relative' }}
                      value={fromDate ? moment(new Date(fromDate)) : fromDate}

                      getPopupContainer={(triggerNode) => {
                        return triggerNode.parentNode;
                      }}
                    />
                  </div>
                  <div className="col-md-1 mb-3"></div>
                  <div className="col-md-2 mb-3">
                    <label htmlFor="location_name" className="form-label">
                      To Date*
                    </label>
                  </div>
                  <div className="col-md-3 mb-3">
                    <DatePicker size="large" format='MM-DD-YYYY' placeholder='mm-dd-yyyy'
                      onChange={(date, dateString) => setToDate(date)} style={{ width: '100%' }}
                      value={toDate ? moment(new Date(toDate)) : toDate}
                      getPopupContainer={(triggerNode) => {
                        return triggerNode.parentNode;
                      }}
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-2  mt-3"></div>
                  <div className="col-md-10 mt-3 d-flex justify-content-end">
                    {loading ?
                      <button className="btn btn-success" type="button" disabled>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ marginRight: 5 }}></span>
                        Fetch
                      </button>
                      :
                      <button type="submit" className="btn btn-success" onClick={(e) => handleFetch(e)}>
                        Fetch
                      </button>
                    }
                  </div>
                </div>
              </div>
            </div>
          </>) : ""}
          

          {(!fetchClicked || !responseData) ? (
            ""
          ) : (
            <>
              <div className="p-4">
                <table className="min-w-full border border-gray-300 rounded-lg shadow-md">
                  <thead className="bg-gray-200">
                    {/* First row: Country headers */}
                    <tr>
                      {responseData.headers.map((h, idx) => (
                        <th
                          key={idx}
                          colSpan={h.subheaders.length > 0 ? h.subheaders.length : 1}
                          className="px-4 py-2 border text-center"
                        >
                          {h.header}
                        </th>
                      ))}
                    </tr>
                    {/* Second row: Airport codes */}
                    <tr>
                      {responseData.headers.map((h, idx) =>
                        h.subheaders.length > 0 ? (
                          h.subheaders.map((sub, i) => (
                            <th key={`${idx}-${i}`} className="px-4 py-2 border">
                              {sub.code}
                            </th>
                          ))
                        ) : (
                          <th key={idx} className="px-4 py-2 border"></th>
                        )
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {responseData.rows.map((row, idx) => (
                      <tr key={idx} className="text-center">
                        {/* OTA name */}
                        <td className="px-4 py-2 border font-semibold">
                          {row.OTA}
                        </td>
                        {/* Country & airport counts */}
                        {responseData.headers.slice(1).map((h, j) =>
                          h.subheaders.length > 0 ? (
                            h.subheaders.map((sub, k) => (
                              <td
                                key={`${idx}-${j}-${k}`}
                                className="px-4 py-2 border"
                              >
                                {row[sub.code] || 0}
                              </td>
                            ))
                          ) : (
                            <td key={`${idx}-${j}`} className="px-4 py-2 border">
                              {row[h.header] || 0}
                            </td>
                          )
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="mt-4">
                <Button onClick={handleDownloadExcel}>Download Excel</Button>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
